export const PROFILE_MUTATION_KEYS = {
    editProfile: 'edit-profile',
    changePassword: 'change-password'
}
